export const saveAuth = (data) => {
  localStorage.setItem("token", data.token);
  localStorage.setItem(
    "user",
    JSON.stringify({
      name: data.name,
      email: data.email,
      role: data.role,
      company: data.company || "",
    }),
  );
};

export const getToken = () => localStorage.getItem("token");

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const isLoggedIn = () => !!getToken();

export const isTokenExpired = () => {
  const token = getToken();
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const hasFullAccess = () => {
  const u = getUser();
  return !!u && (u.role === "ADMIN" || u.role === "MANAGER");
};

// Only ADMIN can delete candidates / users
export const isAdmin = () => {
  const u = getUser();
  return !!u && u.role === "ADMIN";
};

// CLIENT (SPOC) accounts — read-only view of their own positions
export const isClient = () => {
  const u = getUser();
  return !!u && u.role === "CLIENT";
};

export const roleLabel = (role) =>
  ({
    ADMIN: "Administrator",
    MANAGER: "HR Manager",
    RECRUITER: "Recruiter",
    STAFF: "Staff",
    CLIENT: "Client",
  })[role] || role;
